(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_card"] && !Shopify.designMode) return;
  try {
    const CARD_VIDEO_MQ = '(max-width: 749px)';

  function cardAbsolutizeSrc(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function cardIsTouchDevice() {
    try {
      if (window.matchMedia('(pointer: coarse)').matches) return true;
    } catch (e) {
      // ignore
    }
    return (navigator.maxTouchPoints || 0) > 1;
  }

  /**
   * Width-based first. Short-edge fallback (for landscape phones) only
   * applies on touch devices — a laptop with a short browser window (or
   * zoomed out) has a small innerHeight too and must not be treated as
   * mobile just because of that.
   */
  function cardIsMobileVideo() {
    try {
      if (window.matchMedia(CARD_VIDEO_MQ).matches) return true;
    } catch (e) {
      // ignore
    }
    if (cardIsTouchDevice()) {
      const shortEdge = Math.min(window.innerWidth || 0, window.innerHeight || 0);
      const longEdge = Math.max(window.innerWidth || 0, window.innerHeight || 0);
      if (shortEdge > 0 && shortEdge <= 500 && longEdge <= 950) return true;
    }
    return false;
  }

  function cardResponsiveVideoSrc(video) {
    const desktopSrc = video.dataset.desktopSrc;
    const mobileSrc = video.dataset.mobileSrc;
    if (!desktopSrc && !mobileSrc) return '';
    const raw =
      mobileSrc && cardIsMobileVideo() ? mobileSrc : desktopSrc || mobileSrc;
    return cardAbsolutizeSrc(raw);
  }

  function applyCardResponsivePoster(video) {
    const mobilePoster = video.dataset.mobilePoster || '';
    const desktopPoster = video.dataset.desktopPoster || video.getAttribute('poster') || '';
    const nextPoster = cardIsMobileVideo()
      ? mobilePoster || desktopPoster
      : desktopPoster || mobilePoster;
    if (!nextPoster) return;
    const abs =
      nextPoster.indexOf('//') === 0 ? 'https:' + nextPoster : nextPoster;
    if (video.getAttribute('poster') !== abs) video.setAttribute('poster', abs);
  }

  function applyCardResponsiveVideo(video) {
    const slot = video.dataset.bcVideoSlot;
    // Slotted videos: prefer own URL, fall back to the other viewport
    let nextSrc = '';
    if (slot === 'mobile') {
      nextSrc = cardAbsolutizeSrc(video.dataset.mobileSrc || video.dataset.desktopSrc || '');
    } else if (slot === 'desktop') {
      nextSrc = cardAbsolutizeSrc(video.dataset.desktopSrc || video.dataset.mobileSrc || '');
    } else {
      nextSrc = cardResponsiveVideoSrc(video);
    }
    if (!nextSrc) return;

    const split = video.closest('[data-bc-video-split]');
    if (split) {
      const mobile = cardIsMobileVideo();
      const mobileEl = split.querySelector('[data-bc-video-slot="mobile"]');
      const mobileHasSrc = !!(
        mobileEl &&
        (mobileEl.dataset.mobileSrc || mobileEl.dataset.desktopSrc)
      );
      const useDesktopFallback = mobile && (!mobileEl || !mobileHasSrc);
      split.classList.toggle('is-mobile-fallback-desktop', useDesktopFallback);
      split.classList.toggle('is-mobile-video', mobile && !useDesktopFallback);
      split.classList.toggle('is-desktop-video', !mobile || useDesktopFallback);
    }

    applyCardResponsivePoster(video);
    video.dataset.currentSrc = nextSrc;
    video.removeAttribute('autoplay');
    video.autoplay = false;

    // Magic carousel owns attach/play — never preload=auto (4G buffer cost)
    if (video.closest('[data-magic-carousel]')) {
      video.preload = 'none';
      video.setAttribute('preload', 'none');
      return;
    }

    // Non-magic: only attach the active slot (respect desktop fallback on phones)
    const splitHost = video.closest('[data-bc-video-split]');
    const forceDesktop = splitHost?.classList.contains('is-mobile-fallback-desktop');
    if (slot === 'mobile' && (!cardIsMobileVideo() || forceDesktop)) return;
    if (slot === 'desktop' && cardIsMobileVideo() && !forceDesktop) return;

    video.preload = 'metadata';
    if (video.dataset.appliedSrc === nextSrc) return;
    video.dataset.appliedSrc = nextSrc;
    video.src = nextSrc;
    video.load();
    if (window.BcVideoPerf && typeof window.BcVideoPerf.afterSrcChange === 'function') {
      window.BcVideoPerf.afterSrcChange(video);
    }
  }

  function syncCardResponsiveVideos() {
    document.querySelectorAll('video[data-card-responsive-video]').forEach(applyCardResponsiveVideo);
  }

  syncCardResponsiveVideos();

  const cardVideoMql = window.matchMedia(CARD_VIDEO_MQ);
  const onCardVideoBreakpoint = () => syncCardResponsiveVideos();
  if (cardVideoMql.addEventListener) {
    cardVideoMql.addEventListener('change', onCardVideoBreakpoint);
  } else if (cardVideoMql.addListener) {
    cardVideoMql.addListener(onCardVideoBreakpoint);
  }

  document.addEventListener('shopify:section:load', syncCardResponsiveVideos);
  document.addEventListener('shopify:block:select', syncCardResponsiveVideos);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    const SLIDE_VIDEO_MQ = '(max-width: 749px)';

  function slideResponsiveVideoSrc(video) {
    const desktopSrc = video.dataset.desktopSrc;
    const mobileSrc = video.dataset.mobileSrc;
    if (!desktopSrc && !mobileSrc) return '';
    if (mobileSrc && window.matchMedia(SLIDE_VIDEO_MQ).matches) return mobileSrc;
    return desktopSrc || mobileSrc;
  }

  /**
   * Poster-first: only update pending src. BcVideoPerf attaches/plays when
   * the active slide is in view — never eager-buffer HD on 4G.
   */
  function applySlideResponsiveVideo(video) {
    const nextSrc = slideResponsiveVideoSrc(video);
    if (!nextSrc) return;
    video.dataset.pendingSrc = nextSrc;
    video.preload = 'none';
    video.setAttribute('preload', 'none');
    video.removeAttribute('autoplay');
    video.autoplay = false;
    if (window.BcVideoPerf && typeof window.BcVideoPerf.afterSrcChange === 'function') {
      window.BcVideoPerf.afterSrcChange(video);
    }
  }

  function syncSlideResponsiveVideos() {
    document.querySelectorAll('video[data-slide-responsive-video]').forEach(applySlideResponsiveVideo);
    if (window.BcVideoPerf && typeof window.BcVideoPerf.syncSlideVideos === 'function') {
      window.BcVideoPerf.syncSlideVideos();
    }
  }

  syncSlideResponsiveVideos();

  const slideVideoMql = window.matchMedia(SLIDE_VIDEO_MQ);
  const onSlideVideoBreakpoint = () => syncSlideResponsiveVideos();
  if (slideVideoMql.addEventListener) {
    slideVideoMql.addEventListener('change', onSlideVideoBreakpoint);
  } else if (slideVideoMql.addListener) {
    slideVideoMql.addListener(onSlideVideoBreakpoint);
  }

  document.addEventListener('shopify:section:load', syncSlideResponsiveVideos);
  document.addEventListener('slideshow:select', syncSlideResponsiveVideos);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brightcode-custom-option-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcCustomOptRequiredInit) return;
    window.__bcCustomOptRequiredInit = true;

    /* form.id is shadowed by <input name="id"> — always use getAttribute('id') */
    function formAttrId(form) {
      if (!form || !(form instanceof HTMLFormElement)) return null;
      return form.getAttribute('id') || null;
    }

    function scopeRootForForm(form) {
      if (!form) return document;
      return (
        form.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal, dialog.quick-add-modal') ||
        document
      );
    }

    function pickersForForm(formOrId) {
      var form = null;
      var formId = null;
      if (formOrId instanceof HTMLFormElement) {
        form = formOrId;
        formId = formAttrId(form);
      } else {
        formId = formOrId;
      }
      if (!formId) return [];

      var root = form ? scopeRootForForm(form) : document;
      var pickers = Array.prototype.slice.call(
        root.querySelectorAll(
          '.bc-custom-opt[data-bc-custom-required="1"][data-bc-custom-form="' + formId + '"]'
        )
      );

      /* Never validate PDP pickers from a quick-cart click (or the reverse) */
      if (form) {
        var inQuickCart = Boolean(
          form.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal, dialog.quick-add-modal')
        );
        pickers = pickers.filter(function (picker) {
          var pickerInQuickCart = Boolean(
            picker.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal, dialog.quick-add-modal')
          );
          return pickerInQuickCart === inQuickCart;
        });
      }

      return pickers;
    }

    function isSelected(picker) {
      return Boolean(picker.querySelector('.bc-custom-opt__input:checked'));
    }

    function showError(picker, on) {
      var err = picker.querySelector('[data-bc-custom-error]');
      if (!err) return;
      if (on) {
        err.hidden = false;
        err.removeAttribute('hidden');
        picker.classList.add('bc-custom-opt--invalid');
      } else {
        err.hidden = true;
        err.setAttribute('hidden', '');
        picker.classList.remove('bc-custom-opt--invalid');
      }
    }

    function validateForm(form) {
      var formId = formAttrId(form);
      var pickers = pickersForForm(form || formId);
      if (!pickers.length) return true;
      var ok = true;
      pickers.forEach(function (picker) {
        if (isSelected(picker)) {
          showError(picker, false);
        } else {
          showError(picker, true);
          ok = false;
        }
      });
      return ok;
    }

    var PURCHASE_SELECTOR = [
      '[ref="addToCartButton"]',
      'add-to-cart-component',
      '.shopify-payment-button',
      'shopify-accelerated-checkout',
      'shopify-buy-it-now-button',
      '.shopify-payment-button__button',
      'button[name="add"]',
      '.buy-buttons-block button[type="submit"]',
      'sticky-add-to-cart [ref="addToCartButton"]',
      '.sticky-add-to-cart__button',
    ].join(',');

    /* Prefer composedPath — Buy it now / accelerated checkout may retarget clicks */
    function eventPath(event) {
      if (event && typeof event.composedPath === 'function') {
        try {
          return event.composedPath();
        } catch (e) {
          /* ignore */
        }
      }
      return event && event.target ? [event.target] : [];
    }

    function pathClosest(event, selector) {
      var path = eventPath(event);
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || node.nodeType !== 1 || typeof node.matches !== 'function') continue;
        if (node.matches(selector)) return node;
        if (typeof node.closest === 'function') {
          var hit = node.closest(selector);
          if (hit) return hit;
        }
      }
      return null;
    }

    function resolveForm(event) {
      var form =
        pathClosest(event, 'form[data-type="add-to-cart-form"]') ||
        pathClosest(event, 'form[action*="/cart/add"]');
      if (form) return form;

      var pfc = pathClosest(event, 'product-form-component');
      if (pfc) {
        form = pfc.querySelector('form[data-type="add-to-cart-form"], form');
        if (form) return form;
      }

      var buyBlock = pathClosest(event, '.buy-buttons-block, [data-bc-buy-sticky-mobile]');
      if (buyBlock) {
        form =
          buyBlock.querySelector('form[data-type="add-to-cart-form"]') ||
          (buyBlock.closest('product-form-component') &&
            buyBlock.closest('product-form-component').querySelector('form'));
        if (form) return form;
      }

      var sticky = pathClosest(event, 'sticky-add-to-cart');
      if (sticky) {
        var pid = sticky.getAttribute('data-product-id');
        var section = sticky.closest('.shopify-section');
        if (section && pid) {
          form = section.querySelector(
            'product-form-component[data-product-id="' + pid + '"] form'
          );
          if (form) return form;
        }
      }

      /* Never fall back to an unrelated page form — that blocked Quick Add open on PDP */
      return null;
    }

    function isPurchaseClick(event) {
      /* Quick Add "Choose" opens the modal — never treat as purchase */
      if (pathClosest(event, '.quick-add__button--choose')) return false;
      return Boolean(pathClosest(event, PURCHASE_SELECTOR));
    }

    function cancelAddToCartAnimation(form) {
      var roots = [];
      if (form) roots.push(form);
      var inQuickCart = form
        ? form.closest('#quick-add-dialog, quick-add-dialog, .quick-add-modal, dialog.quick-add-modal')
        : null;
      /* Sticky ATC lives on PDP only — never clear it from a quick-cart validation */
      if (!inQuickCart) {
        var sticky = document.querySelector('sticky-add-to-cart');
        if (sticky) roots.push(sticky);
      }
      roots.forEach(function (root) {
        root.querySelectorAll('[ref="addToCartButton"]').forEach(function (btn) {
          btn.removeAttribute('data-added');
        });
      });
      var flyRoot = inQuickCart || document;
      flyRoot.querySelectorAll('fly-to-cart').forEach(function (el) {
        el.remove();
      });
    }

    function formHasInvalidRequired(form) {
      var formId = formAttrId(form);
      if (!formId || !pickersForForm(form).length) return false;
      return !validateForm(form);
    }

    function blockIfInvalid(event, form) {
      if (!formHasInvalidRequired(form)) return false;
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
      cancelAddToCartAnimation(form);
      /* Theme on:click may animate in the same tick — clear again next frames */
      requestAnimationFrame(function () {
        cancelAddToCartAnimation(form);
        requestAnimationFrame(function () {
          cancelAddToCartAnimation(form);
        });
      });
      var formId = formAttrId(form);
      var root = scopeRootForForm(form);
      var firstInvalid = formId
        ? root.querySelector(
            '.bc-custom-opt.bc-custom-opt--invalid[data-bc-custom-form="' + formId + '"]'
          )
        : null;
      if (firstInvalid && typeof firstInvalid.scrollIntoView === 'function') {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return true;
    }

    /* Stop ATC success animation at source (Horizon on:click can beat capture order) */
    function patchAddToCartComponent() {
      var Ctor = customElements.get('add-to-cart-component');
      if (!Ctor || !Ctor.prototype || Ctor.prototype.__bcCustomOptPatched) return;
      var original = Ctor.prototype.handleClick;
      if (typeof original !== 'function') return;
      Ctor.prototype.handleClick = function (event) {
        var form = this.closest('form');
        if (form && formHasInvalidRequired(form)) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          }
          cancelAddToCartAnimation(form);
          return;
        }
        return original.call(this, event);
      };
      Ctor.prototype.__bcCustomOptPatched = true;
    }

    if (customElements.get('add-to-cart-component')) {
      patchAddToCartComponent();
    } else if (customElements.whenDefined) {
      customElements.whenDefined('add-to-cart-component').then(patchAddToCartComponent);
    }

    document.addEventListener(
      'click',
      function (event) {
        if (!isPurchaseClick(event)) return;
        var form = resolveForm(event);
        if (!form) return;
        blockIfInvalid(event, form);
      },
      true
    );

    /* Accelerated checkout often fires pointerdown before click */
    document.addEventListener(
      'pointerdown',
      function (event) {
        if (!isPurchaseClick(event)) return;
        var form = resolveForm(event);
        if (!form) return;
        blockIfInvalid(event, form);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        blockIfInvalid(event, form);
      },
      true
    );

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.classList || !input.classList.contains('bc-custom-opt__input')) return;
      var picker = input.closest('.bc-custom-opt[data-bc-custom-required="1"]');
      if (picker && isSelected(picker)) showError(picker, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brightcode-offer-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcOfferInit) return;
    window.__bcOfferInit = true;

    function copyText(text, onDone) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onDone).catch(function () {
          fallback(text, onDone);
        });
      } else {
        fallback(text, onDone);
      }
    }

    function fallback(text, onDone) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (e) {}
      if (onDone) onDone();
    }

    function setupRoot(root) {
      if (root.dataset.bcOfferReady === '1') return;
      root.dataset.bcOfferReady = '1';

      var scroller = root.querySelector('[data-bc-offer-scroller]');
      var dotsWrap = root.querySelector('[data-bc-offer-dots]');
      if (!scroller) return;

      var cards = scroller.querySelectorAll('.bc-offer-card');
      var count = cards.length;
      if (!count) return;

      var idx = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-bc-offer-autoplay') === '1';
      var autoplayMs = parseInt(root.getAttribute('data-bc-offer-autoplay-ms'), 10) || 3200;
      var dots = [];

      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var d = document.createElement('span');
          if (i === 0) d.classList.add('is-on');
          dotsWrap.appendChild(d);
          dots.push(d);
        }
      }

      function step() {
        var first = cards[0];
        if (!first) return 240;
        var styles = window.getComputedStyle(scroller);
        var gap = parseFloat(styles.columnGap || styles.gap) || 12;
        return first.getBoundingClientRect().width + gap;
      }

      function goTo(i) {
        idx = ((i % count) + count) % count;
        scroller.scrollTo({ left: idx * step(), behavior: 'smooth' });
        dots.forEach(function (d, j) {
          d.classList.toggle('is-on', j === idx);
        });
      }

      function sync() {
        var s = step();
        if (s <= 0) return;
        var next = Math.round(scroller.scrollLeft / s);
        next = Math.max(0, Math.min(count - 1, next));
        if (next !== idx) {
          idx = next;
          dots.forEach(function (d, j) {
            d.classList.toggle('is-on', j === idx);
          });
        }
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!autoplay || count < 2) return;
        timer = setInterval(function () {
          goTo(idx + 1);
        }, autoplayMs);
      }

      scroller.addEventListener('scroll', sync, { passive: true });
      scroller.addEventListener('pointerdown', function () {
        stop();
      });
      scroller.addEventListener('pointerup', start);
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          stop();
          goTo(i);
          start();
        });
      });

      start();
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-bc-offer-copy]');
      if (!btn) return;
      e.preventDefault();
      var code = btn.getAttribute('data-bc-offer-copy');
      if (!code) return;
      var label = btn.getAttribute('data-copy-label') || btn.textContent || 'Copy & Apply';
      var copied = btn.getAttribute('data-copied-label') || 'Copied!';
      var shouldApply = btn.hasAttribute('data-bc-offer-apply');
      copyText(code, function () {
        btn.textContent = copied;
        btn.setAttribute('data-copied', 'true');
        setTimeout(function () {
          btn.textContent = label;
          btn.removeAttribute('data-copied');
        }, 1600);
        if (!shouldApply) return;
        try {
          var img = new Image();
          img.src = '/discount/' + encodeURIComponent(code) + '?v=' + Date.now();
        } catch (err) {}
      });
    });

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bc-offer-root]').forEach(setupRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brightcode-pincode-check"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcPincodeInit) return;
    window.__bcPincodeInit = true;

    function bindRoot(root) {
      if (!root || root.dataset.bcPincodeBound === '1') return;
      root.dataset.bcPincodeBound = '1';

      var input = root.querySelector('[data-bc-pincode-input]');
      var btn = root.querySelector('[data-bc-pincode-btn]');
      var wrap = root.closest('.bc-pincode');
      var msg = wrap ? wrap.querySelector('[data-bc-pincode-msg]') : null;
      if (!input || !btn || !msg) return;

      var successTpl = msg.getAttribute('data-success-template') || '';
      var errorMsg = msg.getAttribute('data-error-message') || '';
      var processingMsg = msg.getAttribute('data-processing-message') || 'Checking delivery to [pincode]…';
      var defaultDays = parseInt(msg.getAttribute('data-default-days'), 10) || 5;
      var processingMs = parseInt(msg.getAttribute('data-processing-ms'), 10) || 1400;

      function setMsg(state, html) {
        msg.classList.remove('is-error', 'is-success', 'is-loading');
        if (state) msg.classList.add('is-' + state);
        msg.innerHTML = html;
        msg.classList.toggle('is-visible', html !== '');
      }

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function formatDate(d) {
        try {
          return new Intl.DateTimeFormat('en-IN', {
            weekday: 'short',
            day: '2-digit',
            month: 'short',
          }).format(d);
        } catch (_) {
          var m = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          return d.getDate() + ' ' + m[d.getMonth()];
        }
      }

      function showProcessing(pincode) {
        var line = processingMsg.replace(/\[\s*pincode\s*\]/g, escapeHtml(pincode));
        var html =
          '<span class="bc-pincode__spinner" aria-hidden="true"></span>' +
          '<span>' +
          line +
          '</span>' +
          '<span class="bc-pincode__progress" aria-hidden="true" style="--bc-pincode-ms:' +
          processingMs +
          'ms"><span class="bc-pincode__progress-bar"></span></span>';
        setMsg('loading', html);
      }

      function check() {
        var v = (input.value || '').replace(/\s+/g, '');
        if (!/^[1-9][0-9]{5}$/.test(v)) {
          setMsg('error', escapeHtml(errorMsg));
          return;
        }

        btn.classList.add('is-loading');
        btn.setAttribute('disabled', 'disabled');
        showProcessing(v);

        setTimeout(function () {
          var deliveryDate = new Date();
          deliveryDate.setDate(deliveryDate.getDate() + defaultDays);
          var dateStr = formatDate(deliveryDate);
          var html = successTpl
            .replace(/\[\s*days\s*\]/g, String(defaultDays))
            .replace(/\[\s*pincode\s*\]/g, escapeHtml(v))
            .replace(/\[\s*date\s*\]/g, '<strong>' + escapeHtml(dateStr) + '</strong>');
          setMsg('success', html);
          btn.classList.remove('is-loading');
          btn.removeAttribute('disabled');
        }, processingMs);
      }

      btn.addEventListener('click', check);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          check();
        }
      });
      input.addEventListener('input', function () {
        var cleaned = (input.value || '').replace(/[^0-9]/g, '').slice(0, 6);
        if (cleaned !== input.value) input.value = cleaned;
        if (msg.classList.contains('is-visible')) setMsg('', '');
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bc-pincode]').forEach(bindRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brightcode-sibling-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcSiblingsOverlayInitV2) return;
    window.__bcSiblingsOverlayInitV2 = true;

    function placeOverlay(el) {
      if (!el || el.dataset.bcSiblingsPlaced === '1') return;
      if (!el.hasAttribute('data-bc-siblings-overlay')) return;
      if (el.closest('.product-details')) return;

      var card = el.closest('product-card, .product-card');
      if (!card) return;

      var gallery = card.querySelector('.card-gallery');
      if (!gallery) {
        el.dataset.bcSiblingsPlaced = '1';
        return;
      }
      if (gallery.contains(el)) {
        el.dataset.bcSiblingsPlaced = '1';
        return;
      }

      var parent = el.parentElement;
      gallery.appendChild(el);
      el.dataset.bcSiblingsPlaced = '1';

      /* Collapse leftover Shopify wrapper so it doesn't push content below the image */
      if (
        parent &&
        parent.classList &&
        parent.classList.contains('shopify-block') &&
        parent.childElementCount === 0
      ) {
        parent.style.display = 'none';
        parent.setAttribute('aria-hidden', 'true');
      }
    }

    function initAll(scope) {
      var root = scope || document;
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-bc-siblings-overlay="1"]').forEach(placeOverlay);
    }

    function onNode(node) {
      if (!node || node.nodeType !== 1) return;
      if (node.matches && node.matches('[data-bc-siblings-overlay="1"]')) {
        placeOverlay(node);
      }
      if (node.querySelectorAll) initAll(node);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });

    /* Infinite scroll appends cards via results-list — re-place overlays */
    if (typeof MutationObserver !== 'undefined') {
      var moTimer = null;
      var mo = new MutationObserver(function (mutations) {
        var needs = false;
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (
              (n.matches && n.matches('[data-bc-siblings-overlay="1"], product-card, .product-card, .product-grid__item')) ||
              (n.querySelector && n.querySelector('[data-bc-siblings-overlay="1"]'))
            ) {
              needs = true;
              onNode(n);
            }
          }
        }
        if (!needs) return;
        if (moTimer) clearTimeout(moTimer);
        moTimer = setTimeout(function () {
          initAll(document);
        }, 50);
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brightcode-wishlist-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcWlOverlayInit) return;
    window.__bcWlOverlayInit = true;

    function isTitleNode(n) {
      if (!n || n.nodeType !== 1) return false;
      if (n.classList && (n.classList.contains('bc-product-title') || n.classList.contains('text-block'))) {
        return true;
      }
      if (n.matches && n.matches('h1, h2, h3, [role="heading"]')) return true;
      return !!(
        n.querySelector &&
        n.querySelector(
          'h1, h2, h3, [role="heading"], .bc-product-title, .text-block.h1, .text-block.h2, .text-block.h3'
        )
      );
    }

    function findTitleSibling(el) {
      var nodes = [el.nextElementSibling, el.previousElementSibling];
      for (var i = 0; i < nodes.length; i++) {
        if (isTitleNode(nodes[i])) return nodes[i];
      }
      var parent = el.parentElement;
      if (!parent) return null;
      var kids = parent.children;
      for (var k = 0; k < kids.length; k++) {
        if (kids[k] === el) continue;
        if (isTitleNode(kids[k])) return kids[k];
      }
      return null;
    }

    function stackPdp(el) {
      if (!el || el.dataset.bcWlPdpStacked === '1') return;
      if (el.closest('product-card, .product-card, .card-gallery')) return;
      if (!el.closest('.product-details, product-details, .product-information')) return;

      var titleEl = findTitleSibling(el);
      var btn = el.querySelector('.bc-wl-btn');
      if (btn) {
        btn.classList.remove('bc-wl-btn--card');
        btn.classList.add('bc-wl-btn--title');
      }
      el.classList.add('bc-wl-block--pdp');
      el.classList.remove('bc-wl-block--overlay');

      if (!titleEl || titleEl.parentElement !== el.parentElement) {
        el.dataset.bcWlPdpStacked = '1';
        return;
      }

      var row = document.createElement('div');
      row.className = 'bc-wl-title-row';
      var anchor = titleEl.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_PRECEDING ? el : titleEl;
      el.parentNode.insertBefore(row, anchor);
      row.appendChild(titleEl);
      row.appendChild(el);
      el.dataset.bcWlPdpStacked = '1';
    }

    function placeCard(el) {
      if (!el || el.dataset.bcWlPlaced === '1') return;
      if (!el.classList.contains('bc-wl-block--overlay')) {
        el.dataset.bcWlPlaced = '1';
        return;
      }
      var card = el.closest('product-card, .product-card');
      if (!card) {
        stackPdp(el);
        el.dataset.bcWlPlaced = '1';
        return;
      }
      var gallery = card.querySelector('.card-gallery');
      if (!gallery || gallery.contains(el)) {
        el.dataset.bcWlPlaced = '1';
        return;
      }
      var parent = el.parentElement;
      gallery.appendChild(el);
      el.dataset.bcWlPlaced = '1';
      if (parent && parent.classList && parent.classList.contains('shopify-block') && parent.childElementCount === 0) {
        parent.style.display = 'none';
      }
    }

    function init(scope) {
      var root = scope || document;
      root.querySelectorAll('.bc-wl-block--overlay, .bc-wl-block--pdp').forEach(function (el) {
        if (el.closest('product-card, .product-card, .card-gallery')) placeCard(el);
        else stackPdp(el);
      });
      root.querySelectorAll('.product-details .bc-wl-block, product-details .bc-wl-block').forEach(stackPdp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target || document);
    });

    if (typeof MutationObserver !== 'undefined') {
      var t = null;
      new MutationObserver(function (mutations) {
        var needs = false;
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (
              (n.matches && n.matches('.bc-wl-block, .bc-wl-block--overlay, product-card, .product-card')) ||
              (n.querySelector && n.querySelector('.bc-wl-block'))
            ) {
              needs = true;
            }
          }
        }
        if (!needs) return;
        if (t) clearTimeout(t);
        t = setTimeout(function () {
          init(document);
        }, 50);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcBuyStickyMobileInit) return;
    window.__bcBuyStickyMobileInit = true;

    function setup(anchor) {
      if (!anchor || anchor.dataset.bcBuyStickyReady === '1') return;
      var bar = anchor.querySelector('[data-bc-buy-sticky-mobile]');
      if (!bar) return;
      anchor.dataset.bcBuyStickyReady = '1';

      var syncHeight = function () {
        var h = Math.ceil(bar.getBoundingClientRect().height);
        if (h > 0) {
          document.documentElement.style.setProperty('--bc-buy-sticky-height', h + 'px');
        }
      };
      syncHeight();
      window.addEventListener('resize', syncHeight, { passive: true });

      // IMPORTANT: layout <footer> often has height:0 (section group / cart drawer).
      // Observe real in-flow footer content, or sticky bar stays permanently hidden.
      var footerTarget =
        document.querySelector('.footer-content') ||
        document.querySelector('footer .shopify-section:not(.cart-drawer-section)') ||
        document.querySelector('[class*="footer-group"] .shopify-section:not(.cart-drawer-section)');
      if (!footerTarget || typeof IntersectionObserver === 'undefined') return;

      var hiddenByFooter = false;
      var notifyFooterChrome = function (hidden) {
        document.documentElement.dataset.bcPdpFooterChromeHidden = hidden ? 'true' : 'false';
        document.dispatchEvent(
          new CustomEvent('bc:pdp-footer-chrome', { detail: { hidden: Boolean(hidden) } })
        );
      };
      var setHidden = function (hidden) {
        if (hidden) {
          hiddenByFooter = true;
          bar.classList.add('is-hidden-by-footer');
          bar.setAttribute('aria-hidden', 'true');
          /* Collapse page-end clearance while the bar is off-screen */
          document.documentElement.style.setProperty('--bc-buy-sticky-height', '0px');
          notifyFooterChrome(true);
        } else if (hiddenByFooter) {
          hiddenByFooter = false;
          bar.classList.remove('is-hidden-by-footer');
          bar.removeAttribute('aria-hidden');
          syncHeight();
          notifyFooterChrome(false);
        }
      };
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          setHidden(Boolean(entry.isIntersecting));
        },
        { rootMargin: '0px 0px 160px 0px', threshold: 0 }
      );
      observer.observe(footerTarget);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-bc-buy-sticky-anchor]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-pills"] && !Shopify.designMode) return;
  try {
    (() => {
    function pinPillsStart(root = document) {
      root.querySelectorAll('.bc-collection-pills__list').forEach((list) => {
        if (list.scrollLeft !== 0) list.scrollLeft = 0;
      });
    }

    pinPillsStart();
    requestAnimationFrame(() => pinPillsStart());
    window.addEventListener('pageshow', () => pinPillsStart(), { passive: true });
    document.addEventListener('shopify:section:load', (event) => {
      pinPillsStart(event.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-toolbar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcCollectionToolbarInit) return;
    window.__bcCollectionToolbarInit = true;

    function formatCount(n) {
      var count = Number(n) || 0;
      return count === 1 ? '1 item' : count + ' items';
    }

    function formatDone(n) {
      var count = Number(n) || 0;
      var pattern = 'Done (__COUNT__)';
      var done = document.querySelector('[data-bc-filters-done]');
      if (done && done.getAttribute('data-done-pattern')) {
        pattern = done.getAttribute('data-done-pattern');
      }
      return pattern.replace(/__COUNT__/g, String(count));
    }

    function applyCount(count) {
      if (window.__croFilterMatchCount != null) {
        count = window.__croFilterMatchCount;
      } else if (window.__croPriceFilterActive) {
        if (window.__croPriceMatchCount == null) return;
        count = window.__croPriceMatchCount;
      }
      if (count == null) return;
      var n = Number(count) || 0;
      document.querySelectorAll('[data-bc-collection-count]').forEach(function (el) {
        el.textContent = formatCount(n);
      });
      document.querySelectorAll('[data-bc-filters-done]').forEach(function (el) {
        el.textContent = formatDone(n);
      });
    }

    /** Fallback if declarative on:click misses (drawer must exist in main-collection). */
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target && event.target.closest && event.target.closest('.bc-collection-toolbar__filter');
        if (!btn) return;
        var drawer = document.getElementById('filters-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        event.preventDefault();
        drawer.open();
      },
      true
    );

    document.addEventListener('shopify:collection:update', function (event) {
      var collection = event.collection || (event.detail && event.detail.collection);
      if (collection && collection.productsCount != null) {
        applyCount(collection.productsCount);
      }
      var promise = event.promise || (event.detail && event.detail.promise);
      if (promise && typeof promise.then === 'function') {
        promise.then(function (result) {
          if (result && result.productsCount != null) applyCount(result.productsCount);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bcPopupStackInit) return;
    window.__bcPopupStackInit = true;

    function productRoot(from) {
      return (
        (from &&
          from.closest &&
          (from.closest('.product-details') ||
            from.closest('.product-information') ||
            from.closest('.shopify-section'))) ||
        document.querySelector('.product-details') ||
        document.querySelector('.product-information') ||
        document
      );
    }

    function openHostDialog(host) {
      if (!host) return;
      if (typeof host.showDialog === 'function') {
        host.showDialog();
        return;
      }
      var realBtn = host.querySelector('.popup-link__button');
      if (realBtn) realBtn.click();
    }

    function markHostWrap(host) {
      host.setAttribute('data-bc-popup-hosted', '1');
      var wrap = host.closest('.shopify-block');
      if (wrap) wrap.setAttribute('data-bc-popup-moved', '1');
    }

    function restoreHostIfInsideSlot(host) {
      if (!host || !host.closest('[data-bc-variant-popup-slot]')) return;
      var wrap =
        document.querySelector('.shopify-block[data-bc-popup-moved="1"]') ||
        host.closest('.shopify-block');
      var park =
        wrap ||
        host.closest('.product-details') ||
        host.closest('.product-information') ||
        document.body;
      park.appendChild(host);
    }

    function ensureProxy(host) {
      if (!host || !host.hasAttribute('data-bc-popup-stack-variant')) return;
      var root = productRoot(host);
      var slot = root.querySelector('[data-bc-variant-popup-slot]');
      if (!slot) return;

      restoreHostIfInsideSlot(host);
      markHostWrap(host);

      var existing = slot.querySelector('[data-bc-popup-proxy]');
      if (existing && existing._bcPopupHost === host) return;
      if (existing) existing.remove();

      var realBtn = host.querySelector('.popup-link__button');
      var proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.setAttribute('data-bc-popup-proxy', '1');
      proxy.className = realBtn ? realBtn.className : 'button button-unstyled popup-link__button';
      proxy.innerHTML = realBtn ? realBtn.innerHTML : '';
      if (realBtn && realBtn.getAttribute('aria-label')) {
        proxy.setAttribute('aria-label', realBtn.getAttribute('aria-label'));
      }
      proxy._bcPopupHost = host;
      proxy.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openHostDialog(host);
      });
      slot.appendChild(proxy);

      var form = slot.closest('form.variant-picker__form');
      if (form && !form.dataset.bcPopupSubmitGuard) {
        form.dataset.bcPopupSubmitGuard = '1';
        form.addEventListener('submit', function (event) {
          event.preventDefault();
        });
      }
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-bc-popup-stack-variant]').forEach(ensureProxy);
      document.querySelectorAll('[data-bc-variant-popup-slot]').forEach(function (slot) {
        if (slot.querySelector('[data-bc-popup-proxy]')) return;
        var host = productRoot(slot).querySelector('[data-bc-popup-stack-variant]');
        if (host) ensureProxy(host);
      });
    }

    var scheduled = false;
    function scheduleInit() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        initAll(document);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target || document);
    });
    document.addEventListener('shopify:product:select', scheduleInit);
    document.addEventListener(
      'change',
      function (event) {
        var t = event.target;
        if (t && t.closest && t.closest('variant-picker')) scheduleInit();
      },
      true
    );

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () {
        scheduleInit();
      });
      var startObs = function () {
        document.querySelectorAll('variant-picker').forEach(function (vp) {
          if (vp.dataset.bcPopupObs === '1') return;
          vp.dataset.bcPopupObs = '1';
          obs.observe(vp, { childList: true, subtree: true });
        });
      };
      startObs();
      document.addEventListener('shopify:section:load', startObs);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (() => {
    const MQ = '(max-width: 749px)';

    function place(el) {
      if (!el) return;
      const mobile = window.matchMedia(MQ).matches;
      // Never append inside <media-gallery> — it breaks slideshow/slide layout (alt text bleed).
      const host = document.querySelector('.product-information__media');

      if (!el.dataset.reviewHomeParent && el.parentElement) {
        const match = el.className.match(/rating-wrapper-([\w]+)/);
        const id = 'review-home-' + (match && match[1] ? match[1] : String(Date.now()));
        if (!el.parentElement.id) el.parentElement.id = id;
        el.dataset.reviewHomeParent = '#' + el.parentElement.id;
      }

      const homeEl = el.dataset.reviewHomeParent
        ? document.querySelector(el.dataset.reviewHomeParent)
        : null;

      if (mobile && host) {
        if (el.parentElement !== host) host.appendChild(el);
        el.setAttribute('data-review-stacked', '1');
        if (homeEl) homeEl.setAttribute('data-review-home-empty', '1');
      } else {
        el.removeAttribute('data-review-stacked');
        if (homeEl) {
          homeEl.removeAttribute('data-review-home-empty');
          if (el.parentElement !== homeEl) homeEl.appendChild(el);
        }
      }
    }

    function scrollRoot() {
      const page = document.querySelector('.page-wrapper');
      if (page && window.matchMedia('(min-width: 990px)').matches) {
        const overflow = getComputedStyle(page).overflowY;
        if (overflow === 'auto' || overflow === 'scroll' || overflow === 'overlay') return page;
      }
      return document.scrollingElement || document.documentElement;
    }

    function findReviewWidget() {
      const selectors = [
        '#nector-reviews',
        '[id*="nector_loyalty_rewards_review_list"]',
        '#judgeme_product_reviews',
        '.jdgm-rev-widg',
        '.jdgm-widget',
        '[id*="judge_me_reviews_review_widget"]',
        '#looxReviews',
        '.loox-reviews-default',
      ];

      for (const selector of selectors) {
        for (const node of document.querySelectorAll(selector)) {
          if (node.closest('.product-details')) continue;
          const style = getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden') continue;
          const rect = node.getBoundingClientRect();
          if (rect.height < 1) continue;
          return node;
        }
      }

      return null;
    }

    function openClosedAncestors(node) {
      let opened = false;
      let details = node.closest('details');
      while (details) {
        if (!details.open) {
          details.open = true;
          opened = true;
        }
        details = details.parentElement ? details.parentElement.closest('details') : null;
      }
      return opened;
    }

    function scrollToWidget(node) {
      const root = scrollRoot();
      const rootTop =
        root === document.documentElement || root === document.body || root === document.scrollingElement
          ? 0
          : root.getBoundingClientRect().top;
      const top = node.getBoundingClientRect().top - rootTop + root.scrollTop - 16;
      root.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function goToReviews(event) {
      const widget = findReviewWidget();
      if (!widget) return;
      event.preventDefault();
      const opened = openClosedAncestors(widget);
      if (opened) {
        requestAnimationFrame(() => scrollToWidget(widget));
      } else {
        scrollToWidget(widget);
      }
    }

    function bindRatingScroll(el) {
      if (!el || el.dataset.croRatingScrollBound) return;
      el.dataset.croRatingScrollBound = '1';
      el.addEventListener('click', goToReviews);
      el.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        goToReviews(event);
      });
    }

    function run() {
      document.querySelectorAll('[data-review-stack-mobile]').forEach(place);
      document.querySelectorAll('[data-cro-rating-scroll]').forEach(bindRatingScroll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
    window.addEventListener('resize', run, { passive: true });
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
